import { ADD_FEEDBACK, FEEDBACK_ERROR, LOAD_FEEDBACK } from '../actions/types';

const initialState = {
    feedback: null,
    feedbacks: [],
    loading: true,
    error: {}
}


export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case FEEDBACK_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case LOAD_FEEDBACK:
            return {
                ...state,
                feedbacks: payload,
                loading: false,
            };
        case ADD_FEEDBACK:
            return {
                ...state,
                feedbacks: [payload, ...state.feedbacks],
                loading: false
            };
        default:
            return state;
    }
}

